import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useLookupGroup } from "../../../../../contexts/lookup-group-context";
import { ApproverTypes, MultiApprovalTypes, WillBeNotifiedTypes, lookupGroups } from "../../../../../utils/lookup-groups.ts";
import { Accordion, Button, TextBox } from "devextreme-react";
import ApproveHierarchyStepTmplate from "./approve-hierarchy-step.js";
import useAxiosPrivate, { axiosHrPrivate } from "../../../../../api/useAxios.js";
import Form, { GroupItem, Item, Label, RequiredRule, SimpleItem } from "devextreme-react/cjs/form";
import BaseFormWithBreadCrumbs from "../../../../../components/base-form/base-form.js";
import { useParams } from "react-router-dom";
import notify from "devextreme/ui/notify";
import LoaderPage from "../../../../../layouts/loader-page/loader-page.js";
import { useAuth } from "../../../../../contexts/auth.js";
import { getPropsLookupExprForIdText } from "../../../../../utils/default-props.js";

function ApproveHierarchyCard() {

    //#region other use
    const params = useParams()
    const axiosPrivate = useAxiosPrivate(axiosHrPrivate)
    const stepsRef = useRef(null)
    const formRef = useRef(null)
    const { getLookupData } = useLookupGroup()
    const { activeLanguage } = useAuth()
    //#endregion

    //#region useStates
    const [stepsCount, setStepsCount] = useState(0)
    const [additionCount, setAdditionCount] = useState(0)
    const [approverValueList, setApproverValueList] = useState([])
    const [willBeNotifiedList, setWillBeNotifiedList] = useState([])
    const [readOnly, setReadOnly] = useState(false)
    const [dirty, setDirty] = useState(false)
    const [id, setId] = useState(params.id)
    const [dataLoading, setDataLoading] = useState(false)
    const [approveHierarchyTypes, setApproveHierarchyTypes] = useState([]);
    const [formData, setFormData] = useState(
        {
            name: "",
            approveHierarchyTypeId: "",
            approveHierarchySteps: [],
        }
    )
    //#endregion

    const addStep = useCallback(() => {

        var i = formData.approveHierarchySteps?.length ?? 0
        var tmpSteps = [...formData.approveHierarchySteps, getNewStepItem(i + 1)]
        setFormData((prev) => {
            return {
                ...prev,
                approveHierarchySteps: tmpSteps
            }
        })
        //console.log(tmpSteps)

        setAdditionCount(additionCount + 1)
        setDirty(true)
    }, [formData, additionCount])

    const handleFieldDataChanged = useCallback((e) => {
        setDirty(true)
    }, [setDirty])

    const removeStep = useCallback((step) => {
        var tmpSteps = formData.approveHierarchySteps.filter((item) => item.step != step)

        if (tmpSteps.length > 0) {
            tmpSteps = tmpSteps.map((item, index) => {
                return {
                    ...item,
                    step: index + 1
                }
            })
        }

        setFormData((prev) => {
            return {
                ...prev,
                approveHierarchySteps: tmpSteps
            }
        })
        notify(`${step}. Adım kaldırıldı, admılar tekrar sıralandı.`)
        setDirty(true)
    }, [formData, setFormData])

    async function onAfterFetch(data) {
        console.log("init onAfterFetch", data)
        if (data?.approveHierarchySteps?.length == 0)
            return data

        var tmpSteps = data.approveHierarchySteps.sort((a, b) => a.step - b.step)
        return {
            ...data,
            approveHierarchySteps: tmpSteps
        }
    }

    const onContentReady = useCallback((e) => {
        const i = e.component._dataSource._items.length
        stepsRef.current?.instance?.expandItem(i - 1)
    }, [])

    const onAfterSave = useCallback((data) => {
        if (data?.id) {
            //setFormData(data)
        }
    }, [])

    const approveHierarchyTypeEditorOption = useMemo(() => (
        {
            ...getPropsLookupExprForIdText,
            dataSource: approveHierarchyTypes,
            //onValueChanged: (e) => { setSelectedLeaveType(e.value) }
        }), [approveHierarchyTypes]
    )

    useEffect(() => {
        //adding general types
        setApproverValueList([])
        setWillBeNotifiedList([])
        getLookupData(lookupGroups.approverGeneralTypes).then(response => {
            setApproverValueList((prev) => {
                var generals = response.map((item) => (
                    { id: item.id, text: item.text, approverTypeId: ApproverTypes.general }
                ))
                return [...prev, ...generals]
            })
        })

        getLookupData(lookupGroups.willBeNotifiedGeneralTypes).then(response => {
            setWillBeNotifiedList((prev) => {
                var generals = response.map((item) => (
                    { id: item.id, text: item.text, willBeNotifiedTypeId: WillBeNotifiedTypes.general }
                ))
                return [...prev, ...generals]
            })
        })

        //adding positions
        axiosPrivate.get("/api/PositionInfo")
            .then((response) => {
                if (response.data?.data) {
                    let result = response?.data?.data.sort((a, b) => a.order - b.order).
                        map(item => (
                            { id: item.id, text: item.name, approverTypeId: ApproverTypes.position }
                        ))
                    setApproverValueList((prev) => {
                        return [...prev, ...result]
                    })

                    let willBeNotifiedListResult = result.map(item => ({ id: item.id, text: item.text, willBeNotifiedTypeId: WillBeNotifiedTypes.position }))
                    setWillBeNotifiedList((prev) => {
                        return [...prev, ...willBeNotifiedListResult]
                    })
                }
            })
        //adding employees
        axiosPrivate.get("/api/Employee/ComboList")
            .then((response) => {
                if (response.data?.data) {
                    let result = response?.data?.data.sort((a, b) => a.order - b.order).
                        map(item => (
                            { id: item.id, text: item.text, approverTypeId: ApproverTypes.employee }
                        ))
                    setApproverValueList((prev) => {
                        return [...prev, ...result]
                    })

                    let willBeNotifiedListResult = result.map(item => ({ id: item.id, text: item.text, willBeNotifiedTypeId: WillBeNotifiedTypes.employee }))
                    setWillBeNotifiedList((prev) => {
                        return [...prev, ...willBeNotifiedListResult]
                    })
                }
            })

    }, [activeLanguage, getLookupData])


    useEffect(() => {
        getLookupData(lookupGroups.approveHierarchyTypes).then(response => setApproveHierarchyTypes(response))
    }, [activeLanguage, getLookupData])

    // useEffect(() => {
    //     console.log("willBeNotifiedList", willBeNotifiedList)
    //     console.log("approverValueList", approverValueList)
    // }, [willBeNotifiedList, approverValueList])

    return (
        <LoaderPage loading={dataLoading}>
            <BaseFormWithBreadCrumbs
                formData={formData}
                setFormData={setFormData}
                formRef={formRef}
                readOnly={readOnly}
                setReadOnly={setReadOnly}
                dirty={dirty}
                setDirty={setDirty}
                loadId={id}
                loadUrl={"/api/ApproveHierarchy/"}
                updateUrl={"/api/ApproveHierarchy/FormData"}
                dataLoading={dataLoading}
                setDataLoading={setDataLoading}
                onAfterFetch={onAfterFetch}
                setId={setId}
            //onAfterSave = {onAfterSave}
            >
                <Form
                    width={600}
                    formData={formData}
                    readOnly={readOnly}
                    onFieldDataChanged={handleFieldDataChanged}
                    ref={formRef}
                >
                    <SimpleItem dataField="name" >
                        <RequiredRule />
                        <Label text="Hiyerarşi Adı" />
                    </SimpleItem>
                    <SimpleItem dataField="approveHierarchyTypeId" editorType="dxSelectBox" editorOptions={approveHierarchyTypeEditorOption}>
                        <RequiredRule />
                        <Label text="Hiyerarşi Türü" />
                    </SimpleItem>
                    <GroupItem>
                        {
                            (formData.approveHierarchySteps?.length > 0)
                            &&
                            <Accordion
                                //    width={500}
                                onContentReady={onContentReady}
                                collapsible={true}
                                ref={stepsRef}
                                dataSource={formData.approveHierarchySteps}
                                itemTitleRender={CustomTitle}
                                itemRender={ApproveHierarchyStepTmplate(approverValueList, willBeNotifiedList, setDirty, removeStep)}
                            >
                            </Accordion>

                        }
                        <div style={{ margin: "10px" }}>
                            <Button text="Adım Ekle" onClick={addStep} />
                        </div>
                    </GroupItem>
                </Form>

            </BaseFormWithBreadCrumbs>
        </LoaderPage>


    )
}

function CustomTitle(stepItem) {
    return (
        <div>
            {`${stepItem.step}. Adım`}
            {/* <span className="delete-step" onClick={(e)=>{ 
                e.stopPropagation();
                notify("Adım silindi")
                }}>Adımı Sil</span> */}
        </div>
    );
}

function getNewStepItem(step) {
    return {
        step: step,
        approveHierarchyId: null,
        multiApprovalTypeId: MultiApprovalTypes.mustApproveAll,
        approveHierarchyStepApprovers: [],
        approveHierarchyStepWillBeNotifieds: []

    }
}
export default ApproveHierarchyCard